"use strict";

import { App } from "./app/app.module";

App.run();